import EA from '../helpers/init';
import { Swiper } from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

export default EA.Methods.swiper = ($this) => {
    const swiper = $this.querySelector('.item-card-swiper');
    const nextBtn = $this.querySelector('.swiper-button-next');
    const prevBtn = $this.querySelector('.swiper-button-prev');

    if (!swiper) return;

    const itemSwiper = new Swiper(swiper, {
        modules: [
            Pagination,
            Navigation,
        ],

        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },

        speed: 1050,

        slidesPerView: 1.05,
        spaceBetween: 16,

        breakpoints: {
            600: {
                slidesPerView: 'auto',
                spaceBetween: 24,
            },
        },

        centerInsufficientSlides: true,
        watchOverflow: false,
        watchSlidesProgress: true,

        //loop: true, 

        
    });

    itemSwiper.slides.forEach((slide, index) => {
        slide.addEventListener('focusin', () => {
            itemSwiper.slideTo(index);
        });
    });
    
};